import {
    SHOW_SIDEBAR_MENU,
    HIDE_SIDEBAR_MENU,
    SET_USER,
    SET_USER_COPY,
    SET_ELECTRON_APP
} from '../constants/actions';

const initialState = {
    sidebarMenuVisible: false,
    user: null,
    userCopy: null,
    electronApp: false
};

const navReducer = (state:{} = initialState, action) => {
    switch (action.type) {
        case SHOW_SIDEBAR_MENU:
            return { ...state, sidebarMenuVisible: true };
        case HIDE_SIDEBAR_MENU:
            return { ...state, sidebarMenuVisible: false };
        case SET_USER:
            return { ...state, user: action.user };
        case SET_USER_COPY:
            return { ...state, userCopy: action.userCopy };
        case SET_ELECTRON_APP:
            return { ...state, electronApp: action.electronApp};
        default:
            return state;
    }
};

export default navReducer;